import { createContext } from "react";

type ApiRequestMethodWithBody = (path: string, payload?: object, config?: Omit<RequestInit, "body" | "method">) => Promise<Response>;
type ApiRequestMethodWithoutBody = (path: string, config?: Omit<RequestInit, "body" | "method">) => Promise<Response>;

export type ApiContextValue = {
  delete: ApiRequestMethodWithBody;
  get: ApiRequestMethodWithoutBody;
  patch: ApiRequestMethodWithBody;
  post: ApiRequestMethodWithBody;
};

export default createContext<ApiContextValue>({
  delete: () => Promise.resolve(new Response()),
  get: () => Promise.resolve(new Response()),
  patch: () => Promise.resolve(new Response()),
  post: () => Promise.resolve(new Response()),
});
